import type { Session } from './storage';
import type { WorkspaceInfo } from './types';

/**
 * Build the Session blob from a `powerpoint-authenticated` postMessage
 * payload.
 *
 * Workspace preselect:
 *   1. Workspace whose `accountName` matches the hint, if any.
 *   2. Otherwise the first workspace in `apps`.
 *
 * `apps` is required — the Showell app's PowerPointService always sends
 * the workspaces list. An empty array means the user has no workspaces;
 * no preselection happens and the resolver will land at `not-synced`.
 */
export function resolveLoginSession(
  accessToken: string,
  hintAccountName: string | null | undefined,
  apps: WorkspaceInfo[],
  userDisplayName: string | null | undefined
): Session {
  const preselectedApp =
    apps.find(a => a.accountName === hintAccountName) ?? apps[0] ?? null;

  return {
    accessToken,
    userName: userDisplayName ?? null,
    accountName: preselectedApp?.accountName ?? hintAccountName ?? null,
    accountId: preselectedApp?.accountId ?? null,
    workspaceDisplayName: preselectedApp?.displayName ?? null,
    applications: apps,
  };
}
